import { AVIS_INICIALITZAR, AVIS_VISUALITZACIO_INSERIR_COMENTARI_EN_CURS,
        AVIS_VISUALITZACIO_INSERIR_COMENTARI_FINALITZADA } from '../../../../actions/actionTypes';

const ESTAT_INICIAL_PETICIO_INSERIR_COMENTARI_EN_CURS = false;

const peticioInserirComentariEnCurs = (state = ESTAT_INICIAL_PETICIO_INSERIR_COMENTARI_EN_CURS, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL_PETICIO_INSERIR_COMENTARI_EN_CURS;

        case AVIS_VISUALITZACIO_INSERIR_COMENTARI_EN_CURS:
            return true;

        case AVIS_VISUALITZACIO_INSERIR_COMENTARI_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioInserirComentariEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/comentaris/peticioInserirEnCurs.js